
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefcorner/privacy-policy",
      function () {
        return require("private-next-pages/debtreliefcorner/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefcorner/privacy-policy"])
      });
    }
  